"use client";

import React from "react";
import DposSessionStep from "./DposSessionStep";

interface EightyEightPayStepProps {
  amount: string;
  onBack: () => void;
  onClose: () => void;
  onCreateNewPayment: () => void;
}

export default function EightyEightPayStep({
  amount,
  onBack,
  onClose,
  onCreateNewPayment,
}: EightyEightPayStepProps) {
  return (
    <DposSessionStep
      amount={amount}
      mode="88pay"
      onBack={onBack}
      onClose={onClose}
      onCreateNewPayment={onCreateNewPayment}
    />
  );
}
